import t from "./isArrayLike.js";
var i = t;
function h(s, e) {
  return function(r, u) {
    if (r == null)
      return r;
    if (!i(r))
      return s(r, u);
    for (var f = r.length, a = e ? f : -1, n = Object(r); (e ? a-- : ++a < f) && u(n[a], a, n) !== !1; )
      ;
    return r;
  };
}
var k = h;
export {
  k as default
};
//# sourceMappingURL=_createBaseEach.js.map
